import DigitalDesignerSortableDigitalJobsList from "../react/DigitalDesignerSortableDigitalJobsList";

export default class DigitalJobsDigitalDesigner {
  perform() {
    const ele = "ready_to_post";
    const jobsData = $(`.js-digital-ads-react-data-${ele}`);

    if (jobsData.length) {
      const list = new DigitalDesignerSortableDigitalJobsList({
        sortScope: `#sort-filters-${ele}`,
        selector: `.js-digital-ads-list-${ele}`,
        data: jobsData.data("jobs"),
        roleType: "digital_designer",
      });

      list.render();
    }
  }
}
